import { Component, Input } from '@angular/core';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-transport-purpose-badge',
  template: ` <zenith-badge zn-emphasis="medium">
    {{ 'components.transport.purpose-badge.purpose.' + purpose | translate }}
  </zenith-badge>`,
  standalone: true,
  imports: [ZenithComponentsModule, TranslateModule]
})
export class TransportPurposeBadgeComponent {
  @Input() purpose: string;
}
